import React from 'react';

export const DoubleChevron: React.FC<{ direction: 'left' | 'right' }> = ({ direction }) => (
    <svg
        viewBox={'0 0 16 16'}
        data-direction={direction}
        xmlns={'http://www.w3.org/2000/svg'}
        className={'sidebar-expand-collapse-chevron'}
        data-testid={'sidebar-expand-collapse-chevron'}
        style={{
            width: '1em',
            height: '1em',
            overflow: 'visible',
            display: 'inline-block',
            verticalAlign: '-0.125em',
            transition: '300ms ease-in-out',
            rotate: `${direction === 'left' ? 0 : 180}deg`,
        }}>
        <path
            strokeWidth={'2'}
            d={
                'M7.354 1.646a.5.5 0 0 1 0 .708L1.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'
            }
        />
        <path
            strokeWidth={'2'}
            d={
                'M13.354 1.646a.5.5 0 0 1 0 .708L7.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'
            }
        />
    </svg>
);
